import { render, staticRenderFns } from "./IncidentsTrendline.vue?vue&type=template&id=1c960cb1&scoped=true"
import script from "./IncidentsTrendline.vue?vue&type=script&lang=js"
export * from "./IncidentsTrendline.vue?vue&type=script&lang=js"
import style0 from "./IncidentsTrendline.vue?vue&type=style&index=0&id=1c960cb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c960cb1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
